import React, { createContext, useContext, useReducer } from 'react';

const notificationContext = createContext();

const reducer = (state, action) => {
  const timeOut = action.severity === 'error' || action.severity === 'warning' ? 500000 : 3000;
  if (action.show) {
    return {
      isOpen: true,
      timeOut,
      severity: action.severity,
      message: action.message,
    };
  } else {
    return { isOpen: false };
  }
};

const NotificationProvider = ({ children }) => {
  const [state, dispatchNotification] = useReducer(reducer, {
    isOpen: false,
  });

  const value = { state, dispatchNotification };

  return (
    <notificationContext.Provider value={value}>
      {children}
    </notificationContext.Provider>
  );
};

const useNotification = () => {
  return useContext(notificationContext);
};

export { NotificationProvider, useNotification };
